import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Box,
  Typography,
} from "@mui/material";
import StoreIcon from "../common/StoreIcon";
import { fCurrency } from "src/utils/formatNumber";

export default function ContractItemsTable(props) {
  return (
    <Box sx={{ p: 0 }}>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
        Contracts
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Coin Amount</TableCell>
              <TableCell>Cost</TableCell>
              <TableCell>Revenue</TableCell>
              <TableCell>Unit Sale</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.rows?.filter((row) => row.amount !== -1).map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <StoreIcon store={row.store} />
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.description}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.amount}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.price}
                </TableCell>
                <TableCell component="th" scope="row">
                  {fCurrency(Math.round(row.totalPrice / 100))}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.totalUnits}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
